import { BUSERS_ROUTES } from '../../constants/_routes'
import busersTypes from '../../constants/busersTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_buser_request = () => {
  return {
    type: busersTypes.create.request
  }
}

const create_buser_success = (response) => {
  return {
    type: busersTypes.create.success,
    payload: response.data.buser
  }
}

const create_buser_failure = (messages) => {
  return {
    type: busersTypes.create.failure,
    payload: messages
  }
}

const create_buser = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_buser_request())

    // Request
    axios.post(
      BUSERS_ROUTES.create,
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "A new user has been connected.")
      dispatch( create_buser_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error connecting user."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_buser_failure(errors))
    })
  }

}

export {
  create_buser
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/create.js